import { apiServer } from "../config/config";
import { fetchWithToken } from "./fetchWithToken";

export async function createNoteTask(
  business_id: string,
  taskName: string,
  token: string,
) {
  const formData = new FormData();
  formData.append("business_id", business_id);
  formData.append("task", taskName);
  const response = await fetchWithToken(
    `${apiServer}/business/create-business-note-task`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    },
  );
  if (!response) {
    return null;
  }
  const responseData = await response.json();
  return responseData;
}

export async function createEnterpriseNote(
  business_id: string,
  locations: { id: number; type: string }[],
  notes: string,
  businessNotesActionId: number,
  token: string,
  taskId?: number,
) {
  const formData = new FormData();
  formData.append("business_id", business_id);
  formData.append("notes", notes);
  formData.append("business_notes_action_id", businessNotesActionId.toString());

  if (taskId) {
    formData.append("business_notes_task_id", taskId.toString());
  }
  for (let i = 0; i < locations.length; i++) {
    formData.append(
      `location_details[${i}][location_id]`,
      locations[i].id.toString(),
    );
    formData.append(`location_details[${i}][location_type]`, locations[i].type);
  }

  const response = await fetchWithToken(
    `${apiServer}/business/create-business-note`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    },
  );
  if (!response) {
    return null;
  }
  const responseData = await response.json();
  if (responseData.errors) {
    if (responseData.errors.location_details.length > 0) {
      throw Error(responseData.errors.location_details[0]);
    }
  }
  return responseData;
}

export async function editEnterpriseNote(
  noteId: number,
  business_id: string,
  locations: { id: number; type: string }[],
  notes: string,
  businessNotesActionId: number,
  token: string,
  taskId?: number,
) {
  const formData = new FormData();
  formData.append("business_note_id", noteId.toString());
  formData.append("business_id", business_id);
  formData.append("notes", notes);
  formData.append("business_notes_action_id", businessNotesActionId.toString());

  if (taskId) {
    formData.append("business_notes_task_id", taskId.toString());
  }
  for (let i = 0; i < locations.length; i++) {
    formData.append(
      `location_details[${i}][location_id]`,
      locations[i].id.toString(),
    );
    formData.append(`location_details[${i}][location_type]`, locations[i].type);
  }

  const response = await fetchWithToken(
    `${apiServer}/business/update-business-note`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    },
  );
  if (!response) {
    return null;
  }
  const responseData = await response.json();
  if (responseData.errors) {
    if (responseData.errors.location_details.length > 0) {
      throw Error(responseData.errors.location_details[0]);
    }
  }
  return responseData;
}

export async function resolveEnterpriseNote(
  noteId: number,
  businessId: string,
  businessAreaId: number,
  token: string,
) {
  const formData = new FormData();

  formData.append("business_id", businessId);
  formData.append("note_id", noteId.toString());
  formData.append("business_notes_area_id", businessAreaId.toString());

  const response = await fetchWithToken(
    `${apiServer}/business/resolve-business-note`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    },
  );
  if (!response) {
    return null;
  }
  const responseData = await response.json();
  if (responseData.errors) {
    if (responseData.errors.location_details.length > 0) {
      throw Error(responseData.errors.location_details[0]);
    }
  }
  return responseData;
}
